import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { Error, PageLayout } from 'core/components';
import { StatusCode } from 'core/constants';
import { Loader } from 'core/elements';
import { ProjectDetails } from 'projects/components';
import { useGetProject } from 'projects/hooks';
import { ProjectJobsProvider } from 'projects/states';

export const ProjectDetailsPage = () => {
  const { id } = useParams();

  const { t } = useTranslation();

  const { record, isLoading, isError } = useGetProject({ id: Number(id) });

  return (
    <PageLayout
      title={
        record?.name
          ? t('titleProjectDetailsWithName', { name: record.name })
          : t('titleProjectDetails')
      }
      hasSwitchVersion
    >
      {isLoading && <Loader />}

      {isError && <Error statusCode={StatusCode.NOT_FOUND} />}

      {record && (
        <ProjectJobsProvider>
          <ProjectDetails project={record} />
        </ProjectJobsProvider>
      )}
    </PageLayout>
  );
};
